import React from 'react';

export const SvgPrintIcon = () => (
  <span>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.4707 15.6666H22.3333C23.5907 15.6666 24.2187 15.6666 24.6093 15.2759C25 14.8853 25 14.2573 25 12.9999V11.6666C25 9.15192 25 7.89592 24.2187 7.11459C23.4373 6.33325 22.1813 6.33325 19.6667 6.33325H6.33333C3.81867 6.33325 2.56267 6.33325 1.78133 7.11459C1 7.89592 1 9.15192 1 11.6666V14.3333C1 14.9613 1 15.2759 1.19467 15.4719C1.39067 15.6666 1.70667 15.6666 2.33333 15.6666H4.52933"
        stroke="#1C86ED"
        strokeWidth="1.5"
      />
      <path
        d="M21 6.33333V4.84C21 3.496 21 2.824 20.7387 2.31067C20.5085 1.85882 20.1412 1.49147 19.6893 1.26133C19.176 1 18.504 1 17.16 1H8.84C7.496 1 6.824 1 6.31067 1.26133C5.85882 1.49147 5.49147 1.85882 5.26133 2.31067C5 2.824 5 3.496 5 4.84V6.33333M5 24.0747V13C5 11.7427 5 11.1147 5.39067 10.724C5.78133 10.3333 6.40933 10.3333 7.66667 10.3333H18.3333C19.5907 10.3333 20.2187 10.3333 20.6093 10.724C21 11.1147 21 11.7427 21 13V24.0747C21 24.4973 21 24.708 20.8613 24.808C20.7227 24.908 20.5227 24.8413 20.1227 24.708L17.2107 23.7373C17.1067 23.7027 17.0547 23.684 17 23.684C16.9467 23.684 16.8933 23.7027 16.7893 23.7373L13.2107 24.9293C13.1067 24.964 13.0547 24.9827 13 24.9827C12.9467 24.9827 12.8933 24.964 12.7893 24.9293L9.21067 23.7373C9.10667 23.7027 9.05467 23.684 9 23.684C8.94667 23.684 8.89333 23.7027 8.78933 23.7373L5.87733 24.708C5.47733 24.8413 5.27733 24.908 5.13867 24.808C5 24.708 5 24.4973 5 24.0747Z"
        stroke="#1C86ED"
        strokeWidth="1.5"
      />
      <path
        d="M10.3333 15.6667H14.3333M10.3333 19.6667H16.3333"
        stroke="#1C86ED"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  </span>
);

export const SvgPrintIconBlack = () => (
  <span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.353 14H19C19.943 14 20.414 14 20.707 13.707C21 13.414 21 12.943 21 12V11C21 9.114 21 8.172 20.414 7.586C19.828 7 18.886 7 17 7H7C5.114 7 4.172 7 3.586 7.586C3 8.172 3 9.114 3 11V13C3 13.471 3 13.707 3.146 13.854C3.293 14 3.53 14 4 14H5.647"
        stroke="#514B4D"
        stroke-width="1.5"
      />
      <path
        d="M18 7V5.88C18 4.872 18 4.368 17.804 3.983C17.6314 3.64411 17.3559 3.36861 17.017 3.196C16.632 3 16.128 3 15.12 3H8.88C7.872 3 7.368 3 6.983 3.196C6.64411 3.36861 6.36861 3.64411 6.196 3.983C6 4.368 6 4.872 6 5.88V7M6 20.306V12C6 11.057 6 10.586 6.293 10.293C6.586 10 7.057 10 8 10H16C16.943 10 17.414 10 17.707 10.293C18 10.586 18 11.057 18 12V20.306C18 20.623 18 20.781 17.896 20.856C17.792 20.931 17.642 20.881 17.342 20.781L15.158 20.053C15.08 20.027 15.041 20.013 15 20.013C14.96 20.013 14.92 20.027 14.842 20.053L12.158 20.947C12.08 20.973 12.041 20.987 12 20.987C11.96 20.987 11.92 20.973 11.842 20.947L9.158 20.053C9.08 20.027 9.041 20.013 9 20.013C8.96 20.013 8.92 20.027 8.842 20.053L6.658 20.781C6.358 20.881 6.208 20.931 6.104 20.856C6 20.781 6 20.623 6 20.306Z"
        stroke="#514B4D"
        stroke-width="1.5"
      />
      <path d="M10 14H13M10 17H14.5" stroke="#514B4D" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  </span>
);
